import { SynchStatus } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";

class HTTPSynchStatusService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<SynchStatus[]> {
    return fetchService
      .fetch(`${this.endpoint}/synch/status`, {})
      .then((r) => r.json())
      .catch((): any[] => []);
  }
}

const regionService: HTTPSynchStatusService = new HTTPSynchStatusService(
  env.endpoint
);

export default regionService;
